import React, { createContext, useContext, useState, useEffect } from 'react';
import { auth } from '../firebase';
import { onAuthStateChanged } from 'firebase/auth';
import { initializeUser } from '../services/userService';
import AppLoadingScreen from '../components/AppLoadingScreen';

// Create auth context
const AuthContext = createContext();

// Auth provider component
export const AuthProvider = ({ children }) => {
  const [currentUser, setCurrentUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [userProfile, setUserProfile] = useState(null);

  useEffect(() => {
    // Subscribe to auth state changes
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      setCurrentUser(user);

      // Auto-initialize user profile when they login
      if (user) {
        try {
          const profile = await initializeUser();
          setUserProfile(profile);

          // Dispatch event to notify components that user was initialized
          window.dispatchEvent(new CustomEvent('userInitialized', {
            detail: { userProfile: profile, isNewUser: profile.createdAt === profile.updatedAt }
          }));
        } catch (error) {
          console.error('Error initializing user profile:', error);
          // Don't block the login process if initialization fails
        }
      } else {
        setUserProfile(null);
      }

      setLoading(false);
    });

    // Cleanup subscription
    return unsubscribe;
  }, []);

  const value = {
    currentUser,
    userProfile,
    loading
  };

  return (
    <AuthContext.Provider value={value}>
      {loading ? (
        <AppLoadingScreen />
      ) : (
        children
      )}
    </AuthContext.Provider>
  );
};

// Custom hook to use auth context
export const useAuth = () => {
  return useContext(AuthContext);
};
